export  const quiz = {
    topic : "React",
    level : "Beginner",
    totalQuestions: 10,
    perQuestionScore: 10,
    questions : [
        {
            question : "Which of the following is used in React.js to increase performance?",
            choices: ["Virtual DOM", "Original DOM", "Both A and B", "None of the above"],
            type: "MCQs",
            correctAnswer: "Virtual DOM",
        },
        {
            question : "Identify the one which is used to pass data to components from outside",
            choices: ["Render with arguments", "setState", "PropTypes", "props"],
            type: "MCQs",
            correctAnswer: "props",
        },
        {
            question : "Who created React.js?",
            choices: ["Jordan Mike", "Jordan Walke", "Tim Lee", "Jordan Lee"],
            type: "MCQs",
            correctAnswer: "Jordan Walke",
        },
        {
            question : "In which language is React.js written?",
            choices: ["Python", "Javascript", "Java", "PHP"],
            type: "MCQs",
            correctAnswer: "Javascript"
        },
        {
            question : "What is Babel?",
            choices: ["Javascript compiler", "Javscript interpreter", "Javascript transpiler", "None of the above"],
            type: "MCQs",
            correctAnswer: "Javascript compiler",
        },
        {
            question : "Which of the following port is the default where webpack-dev-server runs?",
            choices: ["3000", "3306", "3030", "8080"],
            type: "MCQs",
            correctAnswer: "8080",
        },
        {
            question : "How many elements can a valid react component return?",
            choices: ["1 component", "2 components", "3 components", "4 components"],
            type: "MCQs",
            correctAnswer: "1 component",
        },
        {
            question : "A state in React.js is also known as?",
            choices: ["The internal storage of the component", "The external storage of the component", "Permanent storage", "All of the above"],
            type: "MCQs",
            correctAnswer: "The internal storage of the component",
        },
        {
            question : "In MVC, what does React.js act as?",
            choices: ["Modal", "Controller", "View", "Middleware"],
            type: "MCQs",
            correctAnswer: "View",
        },
        {
            question : "Among The following options, choose the one which helps react for keeping their data uni-directional?",
            choices: ["DOM", "Flux", "JSX", "Props"],
            type: "MCQs",
            correctAnswer: "Flux",
        },
    ],
}